module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/bands-djs-tile-0d90bd4be92bda65ab967cb14d4a7824.jpg";